// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1LkS7","sidebarHeading":"Sidebar_sidebarHeading__2UBXe","sidebarSubheading":"Sidebar_sidebarSubheading__e9MJj"};